import { IncidentSummaryComponent } from "./containers/incident-summary/incident-summary.component";
import { Routes } from "@angular/router";

import { MedicationIncidentStepsComponent } from "./containers/medication-incident-steps/medication-incident-steps.component";

export const routes: Routes = [
	{ path: ":incidentId/summary", component: IncidentSummaryComponent },
	{ path: "create", component: MedicationIncidentStepsComponent },
];
